'use client'

import { AdEndpointViews, getAdDecisionByType, hasAd } from '@/app/util/ads-endpoint'
import AdsContext from '@/context/ads'
import UAParserContext from '@/context/ua-parser'
import { useContext } from 'react'
import { desktopWidth } from 'ui/src/constants'

export const DESKTOP_CONTAINER_HEIGHT = 120
export const MOBILE_CONTAINER_HEIGHT = 70
export const DESKTOP_AD_DIMENSIONS = [728, 90]
export const MOBILE_AD_DIMENSIONS = [320, 50]
export const UNIT_NAME = 'top_leaderboard'

const HTLTopLeaderboardAd = () => {
    const { deviceType } = useContext(UAParserContext)
    const { isHTLAdEnabled, pageName } = useContext(AdsContext)
    // eslint-disable-next-line better-tailwindcss/no-unregistered-classes
    const className = `htlad-${deviceType}_${UNIT_NAME}_${pageName}`
    const isEnabled = isHTLAdEnabled(UNIT_NAME)
    return (
        isEnabled && (
            <div className="z-stickyImportantEl bg-giphyDarkestGrey sticky top-0 flex h-[70px] flex-wrap items-center justify-center md:h-[120px]">
                <div className="bg-giphyDarkGrey h-[50px] w-[320px] overflow-auto rounded md:h-[90px] md:w-[728px]">
                    <div className={className}></div>
                </div>
            </div>
        )
    )
}

export const LeaderboardAd = ({ view }: { view: AdEndpointViews }) => {
    const { adServerData, adClientData } = useContext(AdsContext)
    const { deviceType } = useContext(UAParserContext)

    const gifId = getAdDecisionByType(adClientData, view)?.gif.id
    // we need a fixed aspect ratio since this is a sticky ad
    // also it is geotargeted so the dimensions can't be calculated on the server
    const adWidth = deviceType === 'desktop' ? desktopWidth : MOBILE_AD_DIMENSIONS[0]
    const adHeight = deviceType === 'desktop' ? DESKTOP_CONTAINER_HEIGHT : MOBILE_AD_DIMENSIONS[1]
    const aspectRatio = adWidth / adHeight
    const placeholder = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
    return hasAd(view, adServerData) ? (
        <div className="md:w-desktopWidth mx-auto w-full" style={{ aspectRatio }}>
            <img
                src={gifId ? `https://media.giphy.com/media/${gifId}/giphy.webp` : placeholder}
                alt=""
                height={adHeight}
                width={adWidth}
                className="h-full w-full object-cover"
            />
        </div>
    ) : null
}

export default HTLTopLeaderboardAd
